import { queryClient } from 'common/utils/queryClient';
import { QueryKey, UseMutateFunction, useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { ApiAdminUpdatePromptDetailsKey } from '../api/apiReferencesContants';
import { ApiAdminUpdatePromptDetails } from '../api/apiReferences';
import { getAdminGetPromptDetailsKey } from './useAdminGetPromptDetails';

export const getAdminUpdatePromptDetailsKey = (): QueryKey => [ApiAdminUpdatePromptDetailsKey];

const useAdminUpdatePromptDetails = (): {
  mutate: UseMutateFunction<
    void,
    unknown,
    {
      id: number;
      context: string;
      task: string;
      rules: string;
      type: string;
    },
    unknown
  >;
  isLoading: boolean;
} => {
  const { mutate, isLoading } = useMutation(
    getAdminUpdatePromptDetailsKey(),
    async (data: { id: number; context: string; task: string; rules: string; type: string }) => {
      const res = await ApiAdminUpdatePromptDetails(data);
      return res;
    },
    {
      onSuccess: async (_, variables) => {
        notifications.show({
          message: `Prompt updated successfully!`,
          autoClose: 5000,
          sx: (theme) => ({
            padding: theme.spacing.md,
            backgroundColor: theme.black,
          }),
          styles: (theme) => ({
            description: {
              color: theme.colors.green[4],
              fontWeight: 500,
              fontSize: theme.fontSizes.sm,
            },
          }),
        });

        await queryClient.invalidateQueries(getAdminGetPromptDetailsKey(variables.type));
      },
    },
  );

  return {
    mutate,
    isLoading,
  };
};

export default useAdminUpdatePromptDetails;
